<template>
  <main-layout selectedMenu="explore">
    <div class="publishdetail">
      <div class="headerde">
        <a :href="'subjectdetail?id='+ topicId +'&page=4'" class="desingleft">{{topicName}}</a>
        <img fill="red" src="/static/rightdown.svg" />
        <span class="sends">{{typeId == 0?$t('global.发布文章'):$t('global.发布问答')}}</span>
        <a class="publishbtn" @click="saveOrEdit">{{$t('global.发布')}}</a>
      </div>

      <div class="editcomponents">
        <textarea
          class="editinput"
          type="text"
          :placeholder="
          typeId == 0?
          `${$t('global.请输入标题')}（${$t('global.最多')}45${$t('global.个字')}）`:
          `${$t('global.请输入问题')}（${$t('global.最多')}45${$t('global.个字')}）`"
          oninput="if(value.length > 45)value = value.slice(0, 45)"
          v-model="form.title"
        ></textarea>
        <tinymc-editor class="editor" :content="form.content" @changeEdit="updateContent" />
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import tinymcEditor from "@/components/editor/Editor";
export default {
  name: "publishPage",
  components: {
    tinymcEditor,
    MainLayout
  },
  data() {
    return {
      form: {
        id: "",
        title: "",
        content: "",
        typeId: 0,
        topicId: 0
      },
      topicId: 0,
      topicName: "",
      typeId: 0,
      questionId: undefined
    };
  },
  created() {
    this.topicId = this.$query.topicId;
    this.typeId = this.$query.typeId;
    this.questionId = this.$query.id;
    this.topicName = this.$query.topicName;
    this.getQuestion();
  },
  methods: {
    updateContent(content) {
      this.form.content = content;
    },
    saveOrEdit() {
      if (this.form.title == "") {
        this.$message.warning(this.$t("global.标题不能为空"));
        return;
      } else if (this.form.content == "") {
        this.$message.warning(this.$t("global.内容不能为空"));
        return;
      } else if (this.typeId == 0 && this.form.content.length < 300) {
        this.$message.warning(
          `${this.$t("global.内容不得少于")}300${this.$t("global.字")}`
        );
        return;
      }

      this.form.topicId = this.topicId;
      this.form.typeId = this.typeId;

      this.$http
        .post("/api/u/topicquestion/create", this.form)
        .then(response => {
          if (response.code == "OK") {
            this.$router.push(
              "/discussDetail?id=" +
                response.data.id +
                "&topicId=" +
                this.topicId
            );
          } else if (
            response.code == "401" &&
            response.message == this.$t("global.违禁")
          ) {
            this.$message.error(
              this.$t("global.存在违禁词") + "：" + response.data.errMessage
            );
          } else if (
            response.code == "401" &&
            response.message == this.$t("global.建议人工复审")
          ) {
            this.$message.success(
              this.$t("global.发布成功") + "！" + this.$t("global.请等待审核")
            );
          }
        });
    },
    getQuestion() {
      if (this.questionId) {
        this.$http
          .get("/api/u/topicquestion/getQuestion", {
            params: { topicQuestionId: this.questionId, status: 2 }
          })
          .then(response => {
            if (response.code == "OK") {
              this.form = response.data;
            }
          });
      }
    }
  },
  mounted() {
    // if ($.cookie("refresh") != "no") {
    //   setTimeout(function() {
    //     window.location.reload();
    //     $.cookie("refresh", "no");
    //   }, 1000);
    // }
  }
};
</script>

<style scoped>
.publishdetail {
  width: 834px;
  margin: 40px auto 0;
  height: calc(100vh - 255px);
  min-height: 700px;
}
.publishdetail .headerde {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  background-color: #fff;
}
.publishdetail .headerde .desingleft {
  display: inline-block;
  float: left;
  max-width: 550px;
  color: #447bf9;
  margin-left: 36px;
  font-weight: bold;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.headerde .desingleft + img {
  float: left;
  margin-top: 26px;
}
.publishdetail .headerde .sends {
  color: #666;
  font-weight: bold;
}
.publishdetail .headerde img {
  width: 18px;
  height: 18px;
}
.publishdetail .headerde a.publishbtn {
  display: inline-block;
  float: right;
  width: 80px;
  height: 32px;
  color: #0080ff;
  text-align: center;
  line-height: 32px;
  border-radius: 5px;
  margin: 19px 26px 0 0;
  cursor: pointer;
  border: 1px solid rgba(0, 128, 255, 1);
  box-sizing: border-box;
}
.editcomponents {
  margin-top: 20px;
  background-color: #fff;
  box-sizing: border-box;
}
.editinput {
  display: block;
  width: 100%;
  height: 56px;
  border: none;
  outline: none;
  font-size: 24px;
  line-height: 50px;
  padding: 5px 0 0 36px;
  box-sizing: border-box;
}
.edittext {
  border: none;
  width: 100%;
  height: 300px;
  margin-top: 10px;
  outline: none;
  box-sizing: border-box;
}

.editinput::-webkit-input-placeholder {
  color: #999;
  font-size: 30px !important;
}
.editinput::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999;
  font-size: 30px !important;
}
.editinput:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999;
  font-size: 30px !important;
}
.editinput:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #999;
  font-size: 30px !important;
}

input.edittext::-webkit-input-placeholder {
  color: #a1a1a1;
  font-size: 18px;
}
input.edittext::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #a1a1a1;
  font-size: 18px;
}
input.edittext:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #a1a1a1;
  font-size: 18px;
}
input.edittext:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #a1a1a1;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/subject/publishPage.vue